import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminContactInboxPage from "@/pages/admin/AdminContactInboxPage";

export const Route = createFileRoute("/_admin/admin/member-inbox")({
  head: () => pageHead("Admin · Member Inbox", "AKIVA admin · member inbox portal.", "/admin/member-inbox", true),
  component: AdminContactInboxPage,
});
